import {BaseHandler} from "../base/ws";
import {notification} from "antd";
import React, {Component} from 'react';
import {systemBaseEvent} from "../base/baseEvent";

window.reactNotification = notification;

export class NormalMessageHandler extends BaseHandler{

    constructor(){
        super();
    }

    isSupport(msg){
        return typeof msg === "string";
    }

    handle(msg){
        notification.info({
            message: msg,
            style: {
                wordBreak: 'break-all'
            },
            // description: msg,
            placement: 'topRight'
        });
    }

}

export class JsonMessageHandler extends BaseHandler{

    constructor(){
        super();
    }

    title;
    content;

    order() {
        return BaseHandler.ORDER_HIGHT - 1;
    }

    isSupport(msg){
        try {
            let {title, content,clientType} = JSON.parse(msg);
            if(title){
                this.title = title;
                this.content = content;
                return true;
            }
            return false;
        }catch (e) {
            // console.error(e);
            return false;
        }
    }

    handle(msg){
        let {title, content, clientType} = JSON.parse(msg);
        if(clientType!=="Mobile"){
            notification.info({
                message: this.title,
                description: <div style={{wordBreak: 'break-all'}}>{this.content}</div>,
                placement: 'topRight'
            });
        }
    }

}
/*
* 用户禁用
* 切换部门，禁用部门等调整到登录，权重最大
* */
export class LogoutMessageHandler extends BaseHandler{

    constructor(){
        super();
    }

    title;
    content;

    order() {
        return BaseHandler.ORDER_HIGHT-4;
    }

    isSupport(msg){
        try {
            let {title, message,code,clientType} = JSON.parse(msg);
            if (title && code === 505 && message) {
                this.title = title;
                this.content = message;
                return true;
            }
            return false;
        }catch (e) {
            // console.error(e);
            return false;
        }
    }

    handle(msg){
        let {title, content, clientType} = JSON.parse(msg);
        if(clientType!=="Mobile"){
            notification.info({
                message: this.title,
                description: <div style={{wordBreak: 'break-all'}}>{this.content}</div>,
                placement: 'topRight',
                duration:2,
                onClose:()=>{
                    window.location.reload()
                }
            });
        }
    }

}

/**
 * 自动下载文件
 * */
export class DownloadFileMessageHandler extends BaseHandler{

    constructor(){
        super();
    }

    title;
    href;
    type;

    order() {
        return BaseHandler.ORDER_HIGHT - 2;
    }

    isSupport(msg){
        try {
            let {type, title, href} = JSON.parse(msg);
            if(type && ["download", "autoDownload"].indexOf(type) !== -1){
                this.title = title;
                this.type = type;
                this.href = href;
                return true;
            }
            return false;
        }catch (e) {
            // console.error(e);
            return false;
        }
    }

    handle(msg){
        if(this.type === "autoDownload"){
            window.open(this.href);
        }
        notification.info({
            message: this.title,
            description: <a target={"_blank"} href={this.href}>{this.href}</a>,
            placement: 'topRight',
            duration: null,
        });
    }

}
/*
* 消息适配器
* 部门区分消息
* */
export class MsgMessageHandler extends BaseHandler {

    constructor() {
        super();
    }

    title;
    content;

    order() {
        return BaseHandler.ORDER_HIGHT - 5;
    }

    isSupport(msg) {
        try {
            let {title, message, code, deptId} = JSON.parse(msg);
            if (title && code === 506 && message && deptId) {
                this.title = title;
                this.content = message;
                this.deptId = deptId;
                return true;
            }
            if (title && code === 507 && message) {
                this.title = title;
                this.content = message;
                this.code = code;
                return true;
            }
            return false;
        } catch (e) {
            // console.error(e);
            return false;
        }
    }

    handle(msg) {
        let {title, content, clientType} = JSON.parse(msg);
        let thisDeptId = window.currentUser.defaultInfo.dept.id;
        if (this.deptId === thisDeptId) {
            notification.info({
                message: this.title,
                description: <div style={{wordBreak: 'break-all'}}>{this.content}</div>,
                placement: 'topRight',
                duration: 2,
                onClose: () => {
                    // window.location.reload()
                }
            });
        }
        if (this.code === 507) {
            // 发送通知：有用户切换了部门
            systemBaseEvent.syncExec("changeDept");
            // 当调用login接口后这个消息会马上接到，所以在这里不能刷页面，否则会导致切换部门后续逻辑中断
            // window.location.reload()
            // notification.info({
            //     message: this.title,
            //     description: this.content,
            //     placement: 'topRight',
            //     duration: 2,
            //     onClose: () => {
            //         window.location.reload()
            //     }
            // });
        }
    }

}
